import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from "@mui/material";

import { TextField } from "../../../components";
import Logo from "../../../assets/grow_logo-removebg-preview.png";
import { colors } from "../../css components/Style";
import { PrimaryLoadingButton } from "../../css components/Button";

export default function FormDisplay({ formikProps }) {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Grid container spacing={6} className="login-grid">
        <Grid size={12} textAlign={"center"}>
          <Typography
            className="form-title"
            style={{ color: colors.growthOSDarkBlue }}
          >
            CONNECTED ID
          </Typography>
          <Typography>
            Forgot your password? No Problem, enter your email and we will send
            you the reset password link!
          </Typography>
        </Grid>

        <Grid size={12}>
          <TextField
            required
            label="Registered email"
            name="email"
            formikProps={formikProps}
            placeholder="Registered email"
          />
        </Grid>

        <Grid size={12}>
          <PrimaryLoadingButton
            fullWidth
            type="submit"
            variant="contained"
            onClick={formikProps.handleSubmit}
            disabled={!formikProps.isValid}
            loading={formikProps.isSubmitting}
          >
            Reset
          </PrimaryLoadingButton>
        </Grid>

        <Grid size={12} textAlign="center">
          <Typography variant="button">
            Go back to?{" "}
            <Typography
              className="forgot-link"
              variant="button"
              style={{ cursor: "pointer", color: colors.growthOSDarkBlue }}
              onClick={() => navigate("/sign-in")}
            >
              Sign In!
            </Typography>
          </Typography>
        </Grid>
      </Grid>

      <div className="footer-branding">
        <span>Powered by</span>
        <div className="growth-os-logo">
          <img
            src={Logo}
            alt="1"
            style={{ height: "25px", position: "relative", top: "-3px" }}
          />
        </div>
      </div>
    </Fragment>
  );
}
